/**
 * Removes the asSavedSearch property from a search request object.
 * This is used when performing a new user-initiated search to ensure
 * the search is not treated as a saved search.
 *
 * @param searchRequestObject - The original search request object
 * @returns A new object without the asSavedSearch property
 */
const removeSavedSearchFlag = (
  searchRequestObject: TSearchRequestObject,
): Omit<TSearchRequestObject, 'asSavedSearch'> => {
  const { asSavedSearch, ...searchRequestWithoutSavedSearch } = searchRequestObject;
  return searchRequestWithoutSavedSearch;
};

export default removeSavedSearchFlag;
